angular
  .module('ciApp')
  .factory('AuthorizeRouteService', ['$rootScope', '$state', 'AuthService', AuthorizeRouteService]);

function AuthorizeRouteService($rootScope, $state, AuthService) {
  return {
    authorize: function() {
      if (AuthService.isLoggedIn()) {
        // TODO: make this permission based and not role based
        // var routeRoles = _.get($rootScope, 'toState.data.roles');
        // if (routeRoles && !AuthService.isInAnyRole(routeRoles)) {
        //   // user is signed in but not authorized for desired state
        //   $state.go('accessdenied');
        // }
      } else {
        // user is not authenticated. Stow the state they wanted before you
        // send them to the sign-in state, so you can return them when you're done
        $rootScope.returnToState = $rootScope.toState;
        $rootScope.returnToStateParams = $rootScope.toStateParams;

        // now, send them to the signin state so they can log in
        $state.go('login');
      }
    }
  };
}



// WEBPACK FOOTER //
// ./common/services/authorize-route.service.js